import 'custom-event-polyfill'
import { mapGetters, mapMutations } from 'vuex'

/**
 * @param paramNameOrderByAgent - name of the query parameter for orderByAgent
 * @returns vue mixin for orderByAgent handling
 */
export default function (paramNameOrderByAgent = 'order_by_agent') {
  return {
    async mounted () {
      const urlParameters = new URLSearchParams(window.location.search)
      const orderByAgent_ = urlParameters.get(paramNameOrderByAgent)
      document.dispatchEvent(new CustomEvent('orderByAgent', { detail: orderByAgent_ }))
      this.storeOrderByAgent(orderByAgent_)
    },
    methods: {
      ...mapMutations('activation/info', [
        'storeOrderByAgent'
      ])
    },
    computed: {
      ...mapGetters('activation/info', [
        'orderByAgent'
      ])
    }
  }
}
